module.exports = __webpack_public_path__ + "img/code-circle-01.8e7418c2.svg";